// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b30977b8","703":"c4dd2489","787":"56ef9619"}[chunkId] + ".chunk.js";
};